import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRejectRecievedImagesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 47,
	viewBox: "0 0 43 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.8949,
			cy: 29.7767,
			rx: 3.76599,
			ry: 3.65561,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 26.2962,
			rx: 17,
			ry: 16.8939,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 39.1658,
			rx: 2.53176,
			ry: 2.61115,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 45.9546,
			rx: 1.0127,
			ry: 1.04446,
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1.04446,
			rx: 1.0127,
			ry: 1.04446,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.5,
			cy: 7.83381,
			rx: 2.5,
			ry: 2.61115,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 43.997C28.9 43.997 37 35.8968 37 25.9965C37 16.0963 28.9 7.99609 19 7.99609C9.1 7.99609 1 16.0963 1 25.9965C1 35.8968 9.1 43.997 19 43.997Z",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 25.8079C29 31.3103 24.52 35.776 19 35.776C13.48 35.776 10.11 30.2338 10.11 30.2338M10.11 30.2338H14.63M10.11 30.2338V35.2178M9 25.8079C9 20.3055 13.44 15.8398 19 15.8398C25.67 15.8398 29 21.3821 29 21.3821M29 21.3821V16.3981M29 21.3821H24.56",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRejectRecievedImagesIcon;
